import { BranchData } from './tree'

export enum BRANCH_TYPE {
  client,
  business_unit,
  note
}

export const DATA: BranchData[] = [
  {
    id: 'a1',
    label: 'ITransact',
    amount: 15,
    childIds: ['a2', 'b2'],
    childIdsString: 'a2 b2',
    type: BRANCH_TYPE.client,
    subBranch: [
      {
        id: 'a2',
        label: 'Safe Banking Investment',
        amount: 9,
        childIds: ['a3', 'b3', 'c3', 'd3'],
        childIdsString: 'a3 b3 c3 d3',
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'a3',
            label:
              'Really-loooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooong',
            amount: 1,
            type: BRANCH_TYPE.note
          },
          {
            id: 'b3',
            label: 'Delta-2-open-note',
            amount: 12,
            type: BRANCH_TYPE.note
          },
          {
            id: 'c3',
            label: 'Delta-3-open-note',
            amount: 42,
            type: BRANCH_TYPE.note
          },
          {
            id: 'd3',
            label: 'Delta-4-open-note',
            amount: 3,
            type: BRANCH_TYPE.note
          }
        ]
      },
      {
        id: 'b2',
        label: 'Maturuity',
        amount: 16,
        childIds: ['e3'],
        childIdsString: 'e3',
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'e3',
            label: 'Portfolio',
            amount: 5,
            type: BRANCH_TYPE.note
          }
        ]
      }
    ]
  },
  {
    id: 'b1',
    label: 'Top level',
    amount: 15,
    childIds: ['c2', 'd2'],
    childIdsString: 'c2 d2',
    type: BRANCH_TYPE.client,
    subBranch: [
      {
        id: 'c2',
        label: 'Banking Investment',
        amount: 9,
        childIds: ['f3', 'g3', 'h3', 'i3'],
        childIdsString: 'f3 g3 h3 i3',
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'f3',
            label:
              'Really-loooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooong',
            amount: 1,
            type: BRANCH_TYPE.note
          },
          {
            id: 'g3',
            label: 'Delta-2-open-note',
            amount: 12,
            type: BRANCH_TYPE.note
          },
          {
            id: 'h3',
            label: 'Delta-3-open-note',
            amount: 42,
            type: BRANCH_TYPE.note
          },
          {
            id: 'i3',
            label: 'GBP transact',
            amount: 3,
            type: BRANCH_TYPE.note
          }
        ]
      },
      {
        id: 'd2',
        label: 'Maturuity',
        amount: 16,
        childIds: ['j3'],
        childIdsString: 'j3',
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'j3',
            label: 'Portfolio',
            amount: 5,
            type: BRANCH_TYPE.note
          }
        ]
      }
    ]
  },
  {
    id: 'c1',
    label: 'Bonds',
    amount: 15,
    childIds: ['e2', 'f2'],
    childIdsString: 'e2 f2',
    type: BRANCH_TYPE.client,
    subBranch: [
      {
        id: 'e2',
        label: 'Safe Banking Investment',
        amount: 9,
        childIds: ['k3', 'l3', 'm3', 'n3'],
        childIdsString: 'k3 l3 m3 n3',
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'k3',
            label:
              'Really-loooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooooong',
            amount: 1,
            type: BRANCH_TYPE.note
          },
          {
            id: 'l3',
            label: 'Delta-2-open-note',
            amount: 12,
            type: BRANCH_TYPE.note
          },
          {
            id: 'm3',
            label: 'Delta-3-open-note',
            amount: 42,
            type: BRANCH_TYPE.note
          },
          {
            id: 'n3',
            label: 'Delta-4-open-note',
            amount: 3,
            type: BRANCH_TYPE.note
          }
        ]
      },
      {
        id: 'f2',
        childIds: ['o3'],
        childIdsString: 'o3',
        label: 'Maturuity',
        amount: 16,
        type: BRANCH_TYPE.business_unit,
        subBranch: [
          {
            id: 'o3',
            label: 'Portfolio',
            amount: 5,
            type: BRANCH_TYPE.note
          }
        ]
      }
    ]
  }
]
